import { useInvoiceService } from "serviceHooks";

function useInvoiceDownload(invoiceId: number) {
  const invoiceService = useInvoiceService();
  const onDownloadClick = async (version?: number) => {
    if (invoiceId) {
      await invoiceService.downloadPdf(invoiceId, version);
      return invoiceId;
    }
  };
  return onDownloadClick;
}

export default useInvoiceDownload;
